import CloseBatchDialog from './CloseBatchDialog';

export default CloseBatchDialog;
